<template>
    <div class="chip rounded-pill" :class="{selected: selected}" :style="{opacity: opacity ? opacity : 0.75}" @click="$emit('click', $event)">
        {{text}}
    </div>
</template>

<script>
export default {
    props: {
        text: { type: String, required: true},
        selected: { type: Boolean, default: false},
        opacity: { type: Number }
    }
}
</script>

<style scoped lang="scss">

.chip {
    opacity: 0.75;
    display: inline-flex;
    align-items: center;
    margin-right: 4px;
    padding: 4px 12px;
    background: #f0f0f0;
    color: #444;
    font-size: 14px;
    border: 2px solid transparent;
    cursor: pointer;
    position: relative;
    flex-shrink: 0;

    &:hover {
        opacity: 1 !important;
    }

    &.selected {
        opacity: 1 !important;
        border: 2px solid #0094FB;
        background: #0094FB20;
    }

    &.selected:before {
        transform: scale(.75);
        position: absolute;
        top: -8px;
        left: -6px;
        content: '';
        margin-right: 6px;
        display: inline-flex;
        width: 20px;
        height: 20px;
        background-image: url(/img/checked-round-icon.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }
}

</style>